import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const BrandStatement = () => {
  const { t } = useLanguage();

  return (
    <section className="py-32 md:py-44 bg-warm-black">
      <div className="container-luxury max-w-4xl mx-auto text-center">
        <motion.p
          className="font-accent text-primary-foreground/70 text-xl md:text-2xl lg:text-3xl leading-[1.6] italic"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
        >
          {t(
            "Arzani is not simply about where you arrive, but how you experience the journey — with intention, refinement, and effortless access to the world's most exceptional moments.",
            "Arzani gaat niet alleen over waar u aankomt, maar hoe u de reis ervaart — met intentie, verfijning en moeiteloze toegang tot 's werelds meest uitzonderlijke momenten."
          )}
        </motion.p>
      </div>
    </section>
  );
};

export default BrandStatement;
